export default __webpack_public_path__ + "img/9e2e9b389ac425134cb2520a5b38702a.svg";